import * as React from "react";
import './OverviewHTMLBlock.pcss';
import {StringHelpers} from "shared/StringHelpers";

/**
 * Rendered HTML Block to be re-used in various detail pages
 * and for the display of p, h2, h3, and li HTML elements
 *
 * @param props
 * @constructor
 */
export const OverviewHTMLBlock = (props:{ html:string}) => {
  const safeHtml = StringHelpers.safeHTML(props.html);
  if(null!=safeHtml) {
    return <div className="overview-html-block" dangerouslySetInnerHTML={{__html: safeHtml}}></div>;
  } else {
    return null;
  }
}
